import { History } from "history";
import { PlanDto } from "../../interfaces/plan/plan.dto";
import { CreatePlanRequest } from "../../interfaces/plan";
import { MediaDto } from "../../interfaces/media";
import { SelectListDto } from "../../models";

//#region Get Plans

export const GET_PLANS = "GET_PLANS";
export const GET_PLANS_SUCCESS: any = "GET_PLANS_SUCCESS";
export const GET_PLANS_ERROR: any = "GET_PLANS_ERROR";

export interface GetPlansAction {
  type: typeof GET_PLANS;
  payload: {
    courseId: string;
    gradeId: string;
  };
}

export interface GetPlansSuccessAction {
  type: typeof GET_PLANS_SUCCESS;
  payload: PlanDto[];
}

export interface GetPlansErrorAction {
  type: typeof GET_PLANS_ERROR;
  payload: any;
}
//#endregion

//#region Get Plan

export const GET_PLAN = "GET_PLAN";
export const GET_PLAN_SUCCESS: any = "GET_PLAN_SUCCESS";
export const GET_PLAN_ERROR: any = "GET_PLAN_ERROR";

export interface GetPlanAction {
  type: typeof GET_PLAN;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetPlanSuccessAction {
  type: typeof GET_PLAN_SUCCESS;
  payload: PlanDto;
}

export interface GetPlanErrorAction {
  type: typeof GET_PLAN_ERROR;
  payload: any;
}
//#endregion

//#region Update Plan

export const UPDATE_PLAN = "UPDATE_PLAN";
export const UPDATE_PLAN_SUCCESS: any = "UPDATE_PLAN_SUCCESS";
export const UPDATE_PLAN_ERROR: any = "UPDATE_PLAN_ERROR";

export interface UpdatePlanAction {
  type: typeof UPDATE_PLAN;
  payload: {
    id: string;
    request: CreatePlanRequest;
    history: History;
  };
}

export interface UpdatePlanSuccessAction {
  type: typeof UPDATE_PLAN_SUCCESS;
  payload: PlanDto;
}

export interface UpdatePlanErrorAction {
  type: typeof UPDATE_PLAN_ERROR;
  payload: any;
}
//#endregion

//#region Upload Plan Image

export const UPLOAD_PLAN_IMAGE = "UPLOAD_PLAN_IMAGE";
export const UPLOAD_PLAN_IMAGE_SUCCESS: any = "UPLOAD_PLAN_IMAGE_SUCCESS";
export const UPLOAD_PLAN_IMAGE_ERROR: any = "UPLOAD_PLAN_IMAGE_ERROR";
export const UPLOAD_PLAN_IMAGE_PROGRESS: any = "UPLOAD_PLAN_IMAGE_PROGRESS";
export const REMOVE_UPLOADED_PLAN_IMAGE: any = "REMOVE_UPLOADED_PLAN_IMAGE";
export const SET_INITIAL_PLAN_IMAGES: any = "SET_INITIAL_PLAN_IMAGES";

export interface UploadPlanImageAction {
  type: typeof UPLOAD_PLAN_IMAGE;
  payload: {
    file: File;
    planId?: string;
    localId: number;
  };
}
export interface UploadPlanImageSuccessAction {
  type: typeof UPLOAD_PLAN_IMAGE_SUCCESS;
  payload: { localId: number; media: MediaDto };
}

export interface UploadPlanImageErrorAction {
  type: typeof UPLOAD_PLAN_IMAGE_ERROR;
  payload: { localId: number; error: any };
}

export interface UploadPlanImageProgressAction {
  type: typeof UPLOAD_PLAN_IMAGE_PROGRESS;
  payload: { localId: number; progress: any };
}

export interface RemoveUploadedPlanImageAction {
  type: typeof REMOVE_UPLOADED_PLAN_IMAGE;
  payload: number;
}

export interface SetInitialPlanImagesAction {
  type: typeof SET_INITIAL_PLAN_IMAGES;
  payload: any;
}
//#endregion

//#region Add Plan

export const ADD_PLAN = "ADD_PLAN";
export const ADD_PLAN_SUCCESS: any = "ADD_PLAN_SUCCESS";
export const ADD_PLAN_ERROR: any = "ADD_PLAN_ERROR";

export interface AddPlanAction {
  type: typeof ADD_PLAN;
  payload: {
    request: CreatePlanRequest;
    history: History;
  };
}

export interface AddPlanSuccessAction {
  type: typeof ADD_PLAN_SUCCESS;
  payload: PlanDto;
}

export interface AddPlanErrorAction {
  type: typeof ADD_PLAN_ERROR;
  payload: any;
}
//#endregion

//#region Delete Plan

export const DELETE_PLAN_CONSENT: any = "DELETE_PLAN_CONSENT";
export const DELETE_PLAN = "DELETE_PLAN";
export const DELETE_PLAN_SUCCESS: any = "DELETE_PLAN_SUCCESS";
export const DELETE_PLAN_ERROR: any = "DELETE_PLAN_ERROR";

export interface DeletePlanConsentAction {
  type: typeof DELETE_PLAN_CONSENT;
  payload: string;
}

export interface DeletePlanAction {
  type: typeof DELETE_PLAN;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeletePlanSuccessAction {
  type: typeof DELETE_PLAN_SUCCESS;
  payload: null;
}

export interface DeletePlanErrorAction {
  type: typeof DELETE_PLAN_ERROR;
  payload: any;
}
//#endregion

//#region Toggle  State
export const TOGGLE_PLAN_STATE = "TOGGLE_PLAN_STATE";
export const TOGGLE_PLAN_STATE_SUCCESS: any = "TOGGLE_PLAN_STATE_SUCCESS";
export const TOGGLE_PLAN_STATE_ERROR: any = "TOGGLE_PLAN_STATE_ERROR";

export interface TogglePlanStateAction {
  type: typeof TOGGLE_PLAN_STATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface TogglePlanStateSuccessAction {
  type: typeof TOGGLE_PLAN_STATE_SUCCESS;
  payload: { id: string };
}

export interface TogglePlanStateErrorAction {
  type: typeof TOGGLE_PLAN_STATE_ERROR;
  payload: any;
}
//#endregion

//#region add edit plan modal
export const TOGGLE_ADD_EDIT_PLAN_MODAL: any = "TOGGLE_ADD_EDIT_PLAN_MODAL";
export interface ToggleAddEditPlanModalAction {
  type: typeof TOGGLE_ADD_EDIT_PLAN_MODAL;
  payload: any;
}
//#endregion

//#region Get Purchasable Plans for Student by providing course and grade id

export const GET_PURCHASEABLE_PLANS_FOR_STUDENT =
  "GET_PURCHASEABLE_PLANS_FOR_STUDENT";
export const GET_PURCHASEABLE_PLANS_FOR_STUDENT_SUCCESS: any =
  "GET_PURCHASEABLE_PLANS_FOR_STUDENT_SUCCESS";
export const GET_PURCHASEABLE_PLANS_FOR_STUDENT_ERROR: any =
  "GET_PURCHASEABLE_PLANS_FOR_STUDENT_ERROR";
export const RESET_PURCHASEABLE_PLANS_FOR_STUDENT: any =
  "RESET_PURCHASEABLE_PLANS_FOR_STUDENT";

export interface GetPurchaseablePlansForStudentAction {
  type: typeof GET_PURCHASEABLE_PLANS_FOR_STUDENT;
  payload: { courseId: string; gradeId: string; userId: string };
}

export interface GetPurchaseablePlansForStudentSuccessAction {
  type: typeof GET_PURCHASEABLE_PLANS_FOR_STUDENT_SUCCESS;
  payload: SelectListDto[];
}

export interface GetPurchaseablePlansForStudentErrorAction {
  type: typeof GET_PURCHASEABLE_PLANS_FOR_STUDENT_ERROR;
  payload: any;
}

export interface ResetPurchaseablePlansForStudentAction {
  type: typeof RESET_PURCHASEABLE_PLANS_FOR_STUDENT;
  payload: any;
}

//#endregion
// Export a union type that represents all possible actions
export type ActionTypes =
  | GetPlansAction
  | GetPlansSuccessAction
  | GetPlansErrorAction
  | GetPlanAction
  | GetPlanSuccessAction
  | GetPlanErrorAction
  | UpdatePlanAction
  | UpdatePlanSuccessAction
  | UpdatePlanErrorAction
  | UploadPlanImageAction
  | UploadPlanImageSuccessAction
  | UploadPlanImageErrorAction
  | AddPlanAction
  | AddPlanSuccessAction
  | AddPlanErrorAction
  | DeletePlanAction
  | DeletePlanConsentAction
  | DeletePlanErrorAction
  | DeletePlanSuccessAction
  | TogglePlanStateAction
  | TogglePlanStateSuccessAction
  | TogglePlanStateErrorAction
  | ToggleAddEditPlanModalAction
  | SetInitialPlanImagesAction
  | GetPurchaseablePlansForStudentAction
  | GetPurchaseablePlansForStudentSuccessAction
  | GetPurchaseablePlansForStudentErrorAction
  | ResetPurchaseablePlansForStudentAction;
